<template>
  <LayoutHeader main="app" :mainStyle="app ? { 'background-image': 'linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5)),url(' + app.rectangle + ')' } : ''" :loadingOverlay="loadingOverlay" :me="me" ref="layout" :lastApp="lastApp" :appHistory="appHistory">
    <article v-if="app">
      <div class="header">
        <div class="headerContainer" :style="{ 'background-image': 'url(' + app.rectangle + '), linear-gradient(180deg, rgba(34,34,34,1) 0%, rgba(0,0,0,1) 65%, rgba(0,0,0,0.65) 100%)' }">
          <!-- <div class="headerInner"> -->
          <!--   <div class="control"> -->
          <!--     <router-link class="play" :to="{ name: 'Play', params: { app: app.path }}"><i class="fa-solid fa-play"></i> いますぐPLAY</router-link> -->
          <!--   </div> -->
          <!-- </div> -->
        </div>
      </div>
      <div class="body">
        <div class="images portraitHidden" v-viewer="options" ref="images">
          <img v-for="(image, index) in app.images" :src="util.variant(image, 'w=180')" class="image" :data-src="image" :key="index" @click="viewImage(index)" />
        </div>
        <div class="title">
          {{ app.title }}
        </div>
        <!-- <div class="genre"> -->
        <!--   {{ app.genre }} -->
        <!-- </div> -->
        <div class="detail" v-html="app.detailHtml">
        </div>
        <!-- <div class="control"> -->
        <!--   <router-link class="play" :to="{ name: 'Play', params: { app: app.path }}"><i class="fa-solid fa-play"></i> いますぐPLAY</router-link> -->
        <!-- </div> -->
      </div>
    </article>
    <div class="fixedPlay" v-if="app">
      <router-link :to="{ name: 'Play', params: { app: app.path }}"><i class="fa-solid fa-play"></i> 無料で今すぐPLAY</router-link>
    </div>
    <template v-if="app && imageIndex !== null">
      <div class="viewer" @click.prevent="clickViewer" ref="viewer">
        <img :src="app.images[imageIndex]" ref="viwerImg" />
      </div>
      <div class="viewerPrev" @click.prevent="prev()">
        <i class="fa-sharp fa-thin fa-circle-chevron-left"></i>
      </div>
      <div class="viewerNext" @click.prevent="next()">
        <i class="fa-sharp fa-thin fa-circle-chevron-right"></i>
      </div>
      <div class="viewerClose">
        <a href="javascript:;" class="close" @click="imageIndex = null"><i class="fa-sharp fa-solid fa-circle-xmark"></i></a>
      </div>
    </template>
    <!-- Squadbeyond site tag - beyond cv event tag: 75433626-eb06-424b-a6cd-932ee19b6484 --><img src='https://sb.feng-shuiindex.net/conversion_event_tags/75433626-eb06-424b-a6cd-932ee19b6484' alt='' width='0' height='0' style='display: none;' /><iframe src='https://sb.feng-shuiindex.net/conversion_event_tags/75433626-eb06-424b-a6cd-932ee19b6484/sessions' width='0' height='0' style='display: none;'></iframe>
  </LayoutHeader>
</template>

<script>
import baseMixin from './base';
import linkifyHtml from 'linkify-html';

export default {
  mixins: [
    baseMixin,
  ],
  data () {
    return {
      imageIndex: null,
    }
  },
  computed: {
    app: {
      get() {
        return this.apps ? this.apps[this.$route.params.app] : null;
      },
    },
  },
  methods: {
    _mounted() {
    },
    _meSeted() {
    },
    _appsSeted() {
      this.setTitle(this.app.title);
    },
    clickViewer(e) {
      if (e.target === this.$refs.viewer) {
        this.imageIndex = null;
      }
      if (e.target === this.$refs.viwerImg) {
        this.next();
      }
    },
    viewImage(index) {
      this.imageIndex = index;
    },
    next() {
      this.imageIndex++;
      if (this.imageIndex >= this.app.images.length) {
        this.imageIndex = 0;
      }
    },
    prev() {
      this.imageIndex--;
      if (this.imageIndex < 0) {
        this.imageIndex = this.app.images.length - 1;
      }
    },
    autoLink(text) {
      return linkifyHtml(text, {
        defaultProtocol: 'https',
        nl2br: true,
        target: {
          url: '_blank',
        },
      });
    },
  }
}
</script>
